export interface InvocationUsage {
  calls7d: number | null
  calls30d: number | null
  callsTotal: number | null
  status: 'incomplete' | 'unavailable'
  asOf?: string
}

export function parseInvocationUsage(value: unknown): InvocationUsage | undefined {
  if (!value || typeof value !== 'object') return undefined
  const raw = value as Record<string, unknown>
  const count = (snake: string, camel: string): number | null => {
    const n = raw[snake] ?? raw[camel]
    return typeof n === 'number' && Number.isSafeInteger(n) && n >= 0 ? n : null
  }
  return {
    calls7d: count('calls_7d', 'calls7d'),
    calls30d: count('calls_30d', 'calls30d'),
    callsTotal: count('calls_total', 'callsTotal'),
    status: raw.status === 'incomplete' ? 'incomplete' : 'unavailable',
    asOf: typeof (raw.as_of ?? raw.asOf) === 'string' ? String(raw.as_of ?? raw.asOf) : undefined,
  }
}
